import { render } from "./PerwakilanDinasTable.vue?vue&type=template&id=f807087c&scoped=true"
import script from "./PerwakilanDinasTable.vue?vue&type=script&lang=js"
export * from "./PerwakilanDinasTable.vue?vue&type=script&lang=js"

import "./PerwakilanDinasTable.vue?vue&type=style&index=0&id=f807087c&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f807087c"]])

export default __exports__